import apiService from 'frontcore/data/api-service/api-service'
import {
  _delete, _get, _patch, _post, _save,
  getUrlQueryParameterFromObject,
} from 'frontcore/utils/communications/apiClient'
import { AbortablePromise } from "frontcore/utils/promises/abortable-promise"
import { getDocumentsURL } from 'frontcore/utils/communications/media'
import { getLocaleFormat } from 'frontend/helpers/dateUtils'
import { HTTP_RESET_CONTENT } from 'frontcore/constants/communications'
import { store } from 'frontend/store/store'

const URL_BASE_ACTIONS = 'actions'
const URL_BASE_ACTIONS_SOURCE = 'actions_sources'
const URL_BASE_ADVISED_FREQUENCY = 'advised-frequency'
const URL_BASE_APPROVALS = 'approvals'
const URL_BASE_AUDIT_PERMISSIONS = 'audit-permissions'
const URL_BASE_AUDIT_PLANNER_CONFIGURATION_KEY = 'configurations/audit-planner'
const URL_BASE_AUDIT_SUBSOURCES_CONFIG_ROLES = 'subsource-audit-config-by-role'
const URL_BASE_AUDIT_SUBSOURCES_CONFIG_TEAMS = 'subsource-audit-config-by-team'

const URL_BASE_CHECK_POINTS_ASSIGNMENT_IN_PERIMETER = 'check-point-assignments-in-perimeter'
const URL_BASE_CHECK_POINTS_ASSIGNMENT = 'check-point-assignments'
const URL_BASE_COMMENTS_AUDITS = 'level_items_in_audit'
const URL_BASE_COMPLIANCE_CASE = 'compliance-case'
const URL_BASE_COMPLIANCE_LEVELS = 'skill-matrix-compliance-levels'
const URL_BASE_CONFIGURATIONS = 'configurations'
const URL_BASE_CORE_EVIDENCES = 'core-evidences'
const URL_BASE_CRITERIA_IN_AUDIT = 'criteria_in_audit'
const URL_BASE_CUSTOMER_PROTECTION = 'customer_protections'
const URL_BASE_DAILY_ROUND_MESSAGES = 'daily-round-messages'
const URL_BASE_DEFECTS = 'defects'
const URL_BASE_DEPARTMENTS = 'departments'
const URL_BASE_DEVIATION = 'deviations'
const URL_BASE_EVIDENCES = 'evidences'
const URL_BASE_FOSES = 'foses'
const URL_BASE_ILU_EVALUATION_RESULT = 'ilu-evaluation-reasons'
const URL_BASE_ILU_MATRIX = 'ilu-matrix'
const URL_BASE_ILU_MATRIX_HISTORY = 'ilu-matrix-history'
const URL_BASE_ILU_NO_COMPLIANT_OBSERVATIONS = 'ilu-no-compliant-observations'
const URL_BASE_M_TOOLS = 'mtools'
const URL_BASE_MASTER_AUDITS_SOURCES = 'master-audit-sources'
const URL_BASE_MODULE_PERMISSIONS = 'modules'
const URL_BASE_MASTER_AUDITS_TEMPLATES = 'templates'
const URL_BASE_NOK_INSTRUCTIONS = 'non_compliance_instructions'
const URL_BASE_PAPER_STANDARDS = 'paper-standards'
const URL_BASE_PERSON_HIERARCHY = 'person-hierarchy'
const URL_BASE_PMM_EQUIPMENTS = 'integrations/pmm/equipments'
const URL_BASE_PPES = 'ppes'
const URL_BASE_PROBLEM_CAUSETOOL = 'cause_tool_criteria_in_problems'
const URL_BASE_PROBLEM_CAUSETOOL_SETTINGS = 'cause_tool_criteria'
const URL_BASE_REFERENCE_STATES = 'reference_states'
const URL_BASE_ROLES = 'roles'
const URL_BASE_STANDARD_COMPLIANCES = 'compliances'
const URL_BASE_STANDARD_COMPLIANCES_HISTORY = 'compliances-history'
const URL_BASE_STANDARD_WORK_REVIEW_OPERATORS = 'swr-operators'
const URL_BASE_TASK_GROUPS_LIST = 'check-point-groups'
const URL_BASE_TASK_GROUPS_PLANNING_LIST = 'check-point-planned-groups'
const URL_BASE_TASK_MANAGER_ACHIEVE_RULES = 'achieve-rules'
const URL_BASE_TASK_MANAGER_ASSESSORS = 'check-point-assessors'
const URL_BASE_TASK_MANAGER_ON_DEMAND_GROUPS_LAUNCHED = 'instant-group-in-schedules-launched'
const URL_BASE_TASK_MANAGER_STANDARD_GROUPS_LAUNCHED = 'check-point-group-launches-launched'
const URL_BASE_TASK_MANAGER_TECHNICAL_MODULE = 'check-point-technical-modules'
const URL_BASE_TASK_MANAGER_TOOLS = 'check-point-tools'
const URL_BASE_TASK_PLANNED_GROUP_SCHEDULES = 'check-point-planned-group-schedules'
const URL_BASE_TEAMS = 'teams'
const URL_BASE_TO_SHARE = 'shared-urls'
const URL_BASE_USERS = 'users'
const URL_BASE_VARIANTS = 'variants'
const URL_PROBLEM_SCALATE_TECHNIQUE = 'problem-escalate-technique'
export const URL_BASE_AUDITS = 'audits'
export const URL_BASE_AUDITS_IN_CALENDAR = 'audits-in-calendar'
export const URL_BASE_AUDITS_SIGNATURES = 'audits-signatures'
export const URL_BASE_AUDITS_SIGN_LOGIN = 'audits-signatures-login'
export const URL_BASE_BULK_PERMISSSIONS = 'bulk-perimeter-permissions'
export const URL_BASE_DAILY_ROUND_CHECK_POINTS = 'daily-round-check-points'
export const URL_BASE_DAILY_ROUND_CHECK_POINTS_CATEGORIES = 'daily-round-check-point-categories'
export const URL_BASE_DAILY_ROUND_SCHEDULE_ENTRIES = 'daily-round-schedule-entries'
export const URL_BASE_EFFICIENCY_INDICATORS = 'efficiency-indicators'
export const URL_BASE_INDICATORS_ASSESSMENT = 'efficiency-assessments'
export const URL_BASE_MY_ROUTINES = 'my-routines'
export const URL_BASE_PEOPLE = 'people'
export const URL_BASE_PERIMETERS = 'perimeters'
export const URL_BASE_PROBLEMS = 'problems'
export const URL_BASE_PROBLEM_CATEGORIES = 'problem-categories'
export const URL_BASE_PROBLEM_CAUSE_CATEGORIES = 'causes_categories'
export const URL_BASE_PRODUCTION_HIERARCHY = 'production-hierarchy'
export const URL_BASE_PROFILE = 'profile'
export const URL_BASE_ROOT_CAUSE = 'root_causes'
export const URL_BASE_STANDARDS = 'standards'
export const URL_BASE_TASK_MANAGER_ASSESSMENTS = 'check-point-assessments'
export const URL_BASE_TASK_MANAGER_CHECK_POINTS = 'check-points'
export const URL_BASE_TASK_MANAGER_CHECK_POINTS_CATEGORIES = 'check-point-categories'
export const URL_BASE_TASK_MANAGER_CHECK_POINTS_INTERVENTION_MODES = 'check-point-intervention-modes'
export const URL_BASE_TASK_MANAGER_CHECK_POINTS_SUPER_CATEGORIES = 'check-point-super-categories'
export const URL_BASE_TASK_MANAGER_CHECK_POINTS_TECHNICAL_MODULES = 'check-point-technical-modules'
export const URL_BASE_TIME_TRACKING = 'time-tracking'
export const URL_BASE_TIME_TRACKING_CATEGORIES = 'time-tracking-categories'
export const URL_BASE_TOKENS = 'tokens'

export function computeAutomagicFrequency () {
  const url = `${URL_BASE_ADVISED_FREQUENCY}/calculate/`
  return _post(url)
}

export function deleteAdvisedFrequency (id) {
  const url = `${URL_BASE_ADVISED_FREQUENCY}/${id}/`
  return _delete(url)
}

export function deleteAdvisedFrequencyByIds (ids) {
  const url = `${URL_BASE_ADVISED_FREQUENCY}/?ids=${ids.join(',')}`
  return _delete(url)
}

export function copyMasterAuditTemplate (id) {
  const url = `${URL_BASE_MASTER_AUDITS_TEMPLATES}/${id}/clone`
  return _post(url)
}

export function uploadTemplate (data) {
  const url = `${URL_BASE_MASTER_AUDITS_TEMPLATES}/`
  return _post(url, data)
}

export function getMasterAuditSources () {
  const url = `${URL_BASE_MASTER_AUDITS_SOURCES}/`
  return _get(url)
}

export function getPatterns () {
  const url = 'patterns/'
  return _get(url)
}

export function saveComplianceCase (data) {
  const url = `${URL_BASE_COMPLIANCE_CASE}/`
  return _save(url, data, true)
}

export function getPDFReport ({ source, perimeterIds, startDate, endDate, operators, auditor, openActions, dateMessage }) {
  const params = {
    perimeters: perimeterIds.join(','),
    from: startDate,
    to: endDate,
    source,
    date_format: getLocaleFormat(),
    format: 'planification_pdf',
  }

  if (operators) { params.operators = operators.split(',') }
  if (auditor) { params.auditor = auditor.split(',') }
  if (openActions) { params.open_actions = openActions }
  if (dateMessage) { params.date_message = dateMessage }

  const queryParams = getUrlQueryParameterFromObject(params)
  const url = `${URL_BASE_AUDITS}/?${queryParams}`
  return _saveBinary(url)
}

export function getPDFStandard (standardId) {
  const url = `standards/${standardId}/?&date_format=${getLocaleFormat()}&format=pdf`
  return _saveBinary(url)
}

export function getConfiguration () {
  const url = `${URL_BASE_CONFIGURATIONS}/front/`
  return _get(url)
}

export function getConfigurationKeys () {
  const url = `${URL_BASE_CONFIGURATIONS}/keys/`
  return _get(url)
}

export function getConfigurationByKeyName (name) {
  const url = `${URL_BASE_CONFIGURATIONS}/keys/?name=${name}`
  return _get(url)
}

export function createConfigurationKey (data) {
  const url = `${URL_BASE_CONFIGURATIONS}/keys/`
  return _save(url, data, true)
}

export function updateConfigurationKey (id, data) {
  const url = `${URL_BASE_CONFIGURATIONS}/keys/${id}/`
  return _patch(url, data)
}

export function getProfile () {
  const url = `${URL_BASE_PROFILE}/`
  return _get(url)
}

export function getUsers (isPersonNull) {
  let url = `${URL_BASE_USERS}/`
  if (isPersonNull) {
    url += `?person_isnull=True`
  }
  return _get(url)
}

export function populateLDAPUsers (credentials) {
  const url = `users-populate-ldap/`
  const data = credentials
  return _save(url, data, true)
}

export function populateSAPUsers () {
  const url = `users-populate-sap/`
  return _save(url, {}, true)
}

export function getUser (id) {
  const url = `${URL_BASE_USERS}/${id}/`
  return _get(url)
}

export function saveUser (data) {
  const url = `${URL_BASE_USERS}/`
  return _save(url, data, true)
}

export function patchUser (id, data) {
  const url = `${URL_BASE_USERS}/${id}/`
  return _patch(url, data)
}

export function getPeople (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_PEOPLE}/?${queryParams}` : `${URL_BASE_TASK_MANAGER_ACHIEVE_RULES}/`
  return _get(url)
}

export function getRoles () {
  const url = `${URL_BASE_ROLES}/`
  return _get(url)
}

export function saveRole (data) {
  const url = `${URL_BASE_ROLES}/`
  return _save(url, data, true)
}

export function patchRole (roleId, data) {
  const url = `${URL_BASE_ROLES}/${roleId}/`
  return _patch(url, data)
}

export function deleteRole (roleId) {
  const url = `${URL_BASE_ROLES}/${roleId}/`
  return _delete(url)
}

export function getTimeTrackingCategories () {
  const url = `${URL_BASE_TIME_TRACKING_CATEGORIES}/`
  return _get(url)
}

export function getProblemCategories () {
  const url = `${URL_BASE_PROBLEM_CATEGORIES}/`
  return _get(url)
}

export function saveTimeTrackingCategory (data) {
  const url = `${URL_BASE_TIME_TRACKING_CATEGORIES}/`
  return _save(url, data, true)
}

export function patchTimeTrackingCategory (id, data) {
  const url = `${URL_BASE_TIME_TRACKING_CATEGORIES}/${id}/`
  return _patch(url, data)
}

export function deleteTimeTrackingCategory (id) {
  const url = `${URL_BASE_TIME_TRACKING_CATEGORIES}/${id}/`
  return _delete(url)
}

export function getModulePermissions () {
  const url = `${URL_BASE_MODULE_PERMISSIONS}/`
  return _get(url)
}

export function updateModulePermissions (id, data) {
  const url = `${URL_BASE_MODULE_PERMISSIONS}/${id}/`
  return _patch(url, data)
}

export function saveAuditPermissions (data, isNew) {
  let url = `${URL_BASE_AUDIT_PERMISSIONS}/`
  if (data.id) {
    url += `${data.id}/`
  }
  return isNew ? _save(url, data, isNew) : _patch(url, data)
}

export function getStandardOperators (perimeterIds) {
  const url = `${URL_BASE_PEOPLE}/?standard_operators_for_perimeters=${perimeterIds.join(',')}&format=min/&active=True`
  return _get(url)
}

/**
 *
 * @param standard {number}
 * @returns {AbortablePromise}
 */
export function getApprovalsByStandard (standard) {
  const url = `${URL_BASE_APPROVALS}/?standard=${standard}`
  return new AbortablePromise((resolve, reject) => {
    _get(url)
      .then(response => {
        if (response?.status === HTTP_RESET_CONTENT) {
          window.history.go(0)
        }
        resolve(response)
      }).catch(e => {
        reject(e)
      })
  })
}

export function savePerson (data) {
  const url = `${URL_BASE_PEOPLE}/?format=permissions`
  store.commit('resetFetchedResponses')
  return _save(url, data, true)
}

export function updatePerson (data, partial = false) {
  const url = `${URL_BASE_PEOPLE}/${data.id}/?format=permissions`
  if (partial) return _patch(url, data)
  return _save(url, data, false)
}

export function deletePerson (id) {
  const url = `${URL_BASE_PEOPLE}/${id}/`
  return _delete(url)
}

export function patchPeople (personId, data) {
  const url = `${URL_BASE_PEOPLE}/${personId}/`
  return _patch(url, data)
}

export function getOperators (perimeterIds) {
  const url = `${URL_BASE_PEOPLE}/?operators_for_perimeters=${perimeterIds.join(',')}&active=True`
  return _get(url)
}

export function getAllPeople (expanded = null) {
  let url = `${URL_BASE_PEOPLE}/`
  if (expanded) url += '&format=expanded'
  return _get(url)
}

export function getAuditSignatures (auditId, expanded = false) {
  const format = expanded ? '&format=expanded' : ''
  const url = `${URL_BASE_AUDITS_SIGNATURES}/?audit=${auditId}${format}`
  return _get(url)
}

export function updateAudit (id, data, parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_AUDITS}/${id}/?${queryParams}` : `${URL_BASE_AUDITS}/${id}`
  return _patch(url, data)
}

export function signAudit (data) {
  const url = `${URL_BASE_AUDITS_SIGNATURES}/`
  return _save(url, data, true)
}

export function getAudit (source, auditId) {
  let queryParams = getUrlQueryParameterFromObject({
    source,
    format: 'expanded',
  }, false)
  queryParams = queryParams !== '' ? `?${queryParams}` : queryParams
  const url = `${URL_BASE_AUDITS}/${auditId}/${queryParams}`

  return _get(url)
}

export function deleteAudit (auditId) {
  const url = `${URL_BASE_AUDITS}/${auditId}/`
  return _delete(url)
}

export function downloadPDFAudit (auditsId) {
  const url = `${URL_BASE_AUDITS}/?ids=${auditsId.join(',')}&format=audit_pdf`
  return _saveBinary(url)
}

export function downloadMasterAuditPDF (auditId) {
  const url = `${URL_BASE_AUDITS}/${auditId}/master-audit-pdf/`
  return _saveBinary(url)
}

function getAuditsUrl (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  return queryParams ? `${URL_BASE_AUDITS}/?${queryParams}` : `${URL_BASE_AUDITS}/`
}

export function getAudits (parameters) {
  const url = getAuditsUrl(parameters)
  return _get(url)
}

export function getAuditsInCalendar (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_AUDITS_IN_CALENDAR}/?${queryParams}` : `${URL_BASE_AUDITS_IN_CALENDAR}/`
  return _get(url)
}

export function downloadExcelAudits (parameters) {
  let url = getAuditsUrl(parameters)
  url += '&format=excel'
  return _saveBinary(url)
}

export function getSubsourcesAuditsConfigByTeams (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_TEAMS}/?${queryParams}`
  return _get(url)
}

export function getSubsourcesAuditsConfigByRoles (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_ROLES}/?${queryParams}`
  return _get(url)
}

export function createSubsourceAuditsConfigByRole (parameters) {
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_ROLES}/`
  return _save(url, parameters, true)
}

export function deleteSubsourceAuditsConfigByRole (id) {
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_ROLES}/${id}/`
  return _delete(url)
}

export function updateSubsourceAuditsConfigByRole (parameters) {
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_ROLES}/${parameters.id}/`
  return _patch(url, parameters)
}

export function createSubsourceAuditsConfigByTeam (parameters) {
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_TEAMS}/`
  return _save(url, parameters, true)
}

export function deleteSubsourceAuditsConfigByTeam (id) {
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_TEAMS}/${id}/`
  return _delete(url)
}

export function updateSubsourceAuditsConfigByTeam (parameters) {
  const url = `${URL_BASE_AUDIT_SUBSOURCES_CONFIG_TEAMS}/${parameters.id}/`
  return _patch(url, parameters)
}

export function getAuditPlannerConfigurationKey () {
  const url = `${URL_BASE_AUDIT_PLANNER_CONFIGURATION_KEY}/`
  return _get(url)
}

export function updateAuditPlannerConfigKey ({ source, value }) {
  const url = `${URL_BASE_AUDIT_PLANNER_CONFIGURATION_KEY}/`
  return _patch(url, { source, value })
}

export function getPlannedAuditsForNotifications (parameters) {
  let url = `${URL_BASE_AUDITS}/`
  if (typeof parameters === 'object') {
    const urlParameters = Object.keys(parameters).map((key) => {
      return `${key}=${parameters[key]}`
    }).join('&')
    url = `${url}?${urlParameters}`
  }
  return _get(url)
}

export function getPlannedAudits (parameters) {
  if (!parameters.hasOwnProperty('observation_date_isnull')) {
    parameters.observation_date_isnull = true
  }
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_AUDITS}/?${queryParams}` : `${URL_BASE_AUDITS}/`
  return _get(url)
}

export function savePlannedAudit (perimeterId, data) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_AUDITS}/`
  return _save(url, data, true)
}

export function deletePlannedAudit (perimeterId, auditId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_AUDITS}/${auditId}/`
  return _delete(url)
}

export function getReferenceState (perimeterId, referenceStateId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_REFERENCE_STATES}/${referenceStateId}/`
  return _get(url)
}

export function getReferenceStatePlan (perimeterId, referenceStateId, planId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_REFERENCE_STATES}/${referenceStateId}/plans/${planId}/`
  return _get(url)
}

export function getReferenceStatePlanTask (perimeterId, referenceStateId, planId, taskId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_REFERENCE_STATES}/${referenceStateId}/plans/${planId}/tasks/${taskId}/`
  return _get(url)
}

export function getReferenceStateLayout (perimeterId, referenceStateId, layoutId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_REFERENCE_STATES}/${referenceStateId}/layouts/${layoutId}/`
  return _get(url)
}

export function getReferenceStateLayoutAnnotation (perimeterId, referenceStateId, layoutId, annotationId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_REFERENCE_STATES}/${referenceStateId}/layouts/${layoutId}/annotations/${annotationId}/`
  return _get(url)
}

export function getStandards (perimeterId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/${URL_BASE_STANDARDS}/`
  return _get(url)
}

export function saveStandardTestResult (standardId, data, isNew) {
  const url = `${URL_BASE_STANDARDS}/${standardId}/test_results/`
  return _save(url, data, isNew)
}

export function savePaperStandard (data) {
  const url = `${URL_BASE_PAPER_STANDARDS}/`
  return _save(url, data, true)
}

export function getAllFOSEs (active) {
  let url = `${URL_BASE_FOSES}/`
  const activeFilter = '?format=min&active='
  if (active != null) url += activeFilter + active
  return _get(url)
}

export function getAllVariants (active) {
  let url = `${URL_BASE_VARIANTS}/`
  const activeFilter = '?format=min&active='
  if (active != null) url += activeFilter + active
  return _get(url)
}

export function getVariant (variantId) {
  const url = `${URL_BASE_VARIANTS}/${variantId}/?format=expanded`
  return _get(url)
}

export function saveVariantTestResult (variantId, data, isNew) {
  const url = `${URL_BASE_VARIANTS}/${variantId}/test_results/`
  return _save(url, data, isNew)
}

export function getTestResult (testResultId) {
  const url = 'test_results/' + testResultId + '/'
  return _get(url)
}

export function getDailyRounds (perimeterId) {
  const url = `daily_rounds/?perimeters=${perimeterId.join(',')}`
  return _get(url)
}

export function saveReference (data) {
  const url = 'review_points_references/'
  return _save(url, data, true)
}

export function deleteReference (referenceId) {
  const url = `review_points_references/${referenceId}/`
  return _delete(url)
}

export function udpateReference (referenceId, data) {
  const url = `review_points_references/${referenceId}/`
  return _patch(url, data)
}

export function saveCommentM4 (data, isNew) {
  let url = `${URL_BASE_COMMENTS_AUDITS}/`
  if (!isNew) {
    url += `${data.id}/`
  }
  return _save(url, data, isNew)
}

export function deleteCommentM4 (commentId) {
  const url = `${URL_BASE_COMMENTS_AUDITS}/${commentId}/`
  return _delete(url)
}

export function getReviewPointsInDailyRound (dailyRoundId) {
  const url = `daily_rounds/${dailyRoundId}/?format=expanded`
  return _get(url)
}

export function updateDailyRound (perimeterId, dailyRoundId, data) {
  const url = `perimeters/${perimeterId}/daily_rounds/${dailyRoundId}/`
  return _save(url, data, false)
}

/**
 * @param { string } url - URL string
 * @param { Record<string, string> | undefined } [headers=undefined] - Header configuration
 * @returns { Promise<Action[]> }
*/
export function getActionsByParameters (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters)
  const url = queryParams ? `${URL_BASE_ACTIONS}/?${queryParams}` : `${URL_BASE_ACTIONS}/`
  return _get(url)
}

export function getActionsExcel (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_ACTIONS}/?${queryParams}`
  return _saveBinary(url)
}
/**
 *
 * @param {number} standardId
 * @returns {AbortablePromise}
 */
export function getActions (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_ACTIONS}/?${queryParams}` : `${URL_BASE_ACTIONS}/`
  return new AbortablePromise((resolve, reject) => {
    _get(url)
      .then(response => {
        resolve(response)
      }).catch(e => {
        reject(e)
      })
  })
}

export function getActionsByIds (ids, format = 'expanded') {
  const url = `${URL_BASE_ACTIONS}/?ids=` + ids.join(',') + `&format=${format}`
  return _get(url)
}

export function getActionById (id, parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_ACTIONS}/${id}/?${queryParams}` : `${URL_BASE_ACTIONS}/${id}`
  return _get(url)
}

export function getActionHistory (id) {
  const url = `actions/${id}/history/`
  return _get(url)
}

export function getTeamActionFollowUp (parameters) {
  parameters.format = 'excel'
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `stats/${URL_BASE_ACTIONS}/${URL_BASE_TEAMS}/?${queryParams}`
  return _saveBinary(url)
}

export function getPersonHistory (id) {
  const url = `people/${id}/history/`
  return _get(url)
}

export function getPerson (id, format) {
  let url = `${URL_BASE_PEOPLE}/${id}/`
  if (format) url += `?format=${format}`
  return _get(url)
}

export function getPersonHierarchy (id) {
  const url = `${URL_BASE_PERSON_HIERARCHY}/${id}/`
  return _get(url)
}

export function deleteActionsByIds (ids) {
  const url = `${URL_BASE_ACTIONS}/?ids=${ids.join(',')}`
  return _delete(url)
}

export function getReviewPoint (perimeterId, reviewPointId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/review_points/${reviewPointId}/`
  return _get(url)
}

export function getReviewPoints (perimeterId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/review_points/`
  return _get(url)
}

export function saveReviewPoint (perimeterId, data) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/review_points/`
  return _save(url, data, true)
}

export function saveAction (data) {
  const url = `${URL_BASE_ACTIONS}/`
  return _save(url, data, true)
}

export function updateAction (actionId, data) {
  const url = `${URL_BASE_ACTIONS}/${actionId}/`
  return _patch(url, data)
}

export function updateReviewPoint (perimeterId, reviewPointId, data) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/review_points/${reviewPointId}/`
  return _patch(url, data)
}

export function patchReviewPoint (perimeterId, reviewPointId, data) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/review_points/${reviewPointId}/`
  return _patch(url, data)
}

export function patchReviewPoints (perimeterId, data) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/review_points/`
  return _patch(url, data)
}

export function deleteReviewPoint (perimeterId, reviewPointId) {
  const url = `${URL_BASE_PERIMETERS}/${perimeterId}/review_points/${reviewPointId}/`
  return _delete(url)
}

export function updateCustomerProtection (problemID, data) {
  const url = `${URL_BASE_CUSTOMER_PROTECTION}/${problemID}/?format=expanded`
  return _patch(url, data)
}

export function setCustomerProtection (data) {
  const url = `${URL_BASE_CUSTOMER_PROTECTION}/`
  return _save(url, data, true)
}

export function setMTool (problemId, data) {
  const url = `${URL_BASE_PROBLEMS}/${problemId}/${URL_BASE_M_TOOLS}/`
  return _save(url, data, true)
}

export function getMTool (problemId) {
  const url = `${URL_BASE_PROBLEMS}/${problemId}/${URL_BASE_M_TOOLS}/`
  return _get(url)
}

export function updateStep (stepId, data) {
  const url = `${URL_BASE_CRITERIA_IN_AUDIT}/${stepId}/`
  return _patch(url, data)
}

export function getCustomerProtection (problemID) {
  let url = `${URL_BASE_CUSTOMER_PROTECTION}/?problem=` + problemID
  url += '&format=expanded'
  return _get(url)
}

export function getEvidences (parameters) {
  let url = `${URL_BASE_EVIDENCES}/?format=expanded`
  const queryParams = getUrlQueryParameterFromObject(parameters)
  if (queryParams) {
    url += '&' + queryParams
  }
  return _get(url)
}

export function getEvidence (evidenceID) {
  let url = `${URL_BASE_EVIDENCES}/${evidenceID}/`
  url += '&format=expanded'
  return _get(url)
}

export function fetchCoreEvidence (evidenceFilterSet) {
  let url = `${URL_BASE_CORE_EVIDENCES}/`
  const queryParams = getUrlQueryParameterFromObject(evidenceFilterSet)
  if (queryParams) {
    url += '?' + queryParams
  }
  return _get(url)
}

export function createEvidence (data) {
  const url = `${URL_BASE_EVIDENCES}/`
  return _save(url, data, true)
}

export function updateEvidence (evidenceId, data) {
  const url = `${URL_BASE_EVIDENCES}/${evidenceId}/`
  return _patch(url, data)
}

export function patchCoreEvidences (data) {
  const url = `${URL_BASE_CORE_EVIDENCES}/`
  return _patch(url, data)
}

export function removeEvidence (evidenceID) {
  const url = `${URL_BASE_EVIDENCES}/${evidenceID}/`
  return _delete(url)
}

function getUrlEfficiencyIndicators (problemId) {
  return `${URL_BASE_PROBLEMS}/${problemId}/${URL_BASE_EFFICIENCY_INDICATORS}/`
}

function getUrlIndicatorsAssessments (indicatorId) {
  return `${URL_BASE_EFFICIENCY_INDICATORS}/${indicatorId}/${URL_BASE_INDICATORS_ASSESSMENT}/`
}

export function getEfficiencyIndicators (problemId) {
  let url = getUrlEfficiencyIndicators(problemId)
  url += '?format=expanded'
  return _get(url)
}

export function addIndicator (problemID, data) {
  const url = getUrlEfficiencyIndicators(problemID)
  return _save(url, data, true)
}

export function updateIndicator (problemID, indicator) {
  let url = getUrlEfficiencyIndicators(problemID)
  url += `${indicator.id}/`
  return _patch(url, indicator)
}

export function deleteIndicator (problemId, indicator) {
  let url = getUrlEfficiencyIndicators(problemId)
  url += `${indicator.id}/`
  return _delete(url)
}

export function addIndicatorAssessment (data, indicatorId) {
  const url = getUrlIndicatorsAssessments(indicatorId)
  return _save(url, data, true)
}

export function updateIndicatorAssessment (data, indicatorId) {
  let url = getUrlIndicatorsAssessments(indicatorId)
  url += `${data.id}/`
  return _patch(url, data)
}

export function getIndicatorAssessments (indicatorId) {
  const url = getUrlIndicatorsAssessments(indicatorId)
  return _get(url)
}

export function getLastOngoingProblem (perimeterIds, startedLt, limit, offset) {
  let url = `${URL_BASE_PROBLEMS}/?perimeters=${perimeterIds.join(',')}`
  url += '&limit=' + limit + '&offset=' + offset
  url += `&status=1`
  if (startedLt) { url += '&started_date_lt=' + startedLt }
  url += '&ordering=-started_date'
  url += '&format=expanded'
  return _get(url)
}

export function getProblems (parameters) {
  parameters.format = 'table'
  const fields = new Set(
    [
      'actions',
      'categories',
      'closable',
      'close_due_date',
      'created_by',
      'description',
      'device_created',
      'follow_up_id',
      'id',
      'indicators',
      'occurrence_date',
      'participants',
      'perimeter',
      'pilot',
      'priority',
      'problem_type',
      'status',
      'supervisor',
      'verification_requested',
      'indicators_summary',
      'closed_date',
    ]
  )

  parameters.fields = [...fields].join(',')
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_PROBLEMS}/?${queryParams}` : `${URL_BASE_PROBLEMS}/`
  return _get(url)
}

export function getProblemsByParameters (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters)
  const url = queryParams ? `${URL_BASE_PROBLEMS}/?${queryParams}` : `${URL_BASE_PROBLEMS}/`
  return _get(url)
}
/**
 * @param { string } url - URL string
 * @param { string } format - Format of the response
 * @returns { Promise<ProblemAPIResponse|Blob> }
 */
export function getProblemsById (id, format = 'expanded') {
  const url = `${URL_BASE_PROBLEMS}/${id}/?date_format=${getLocaleFormat()}&format=${format}`
  if (format === 'pdf') {
    return _saveBinary(url)
  }
  return _get(url)
}

export function isProblemClosable (id) {
  const url = `${URL_BASE_PROBLEMS}/${id}/close-requirements/`
  return _get(url)
}

export function deleteProblem (id) {
  const url = `${URL_BASE_PROBLEMS}/${id}/`
  return _delete(url)
}

export function startProblem (problem, data) {
  const url = `${URL_BASE_PROBLEMS}/${problem.id}/`
  return _patch(url, data)
}

export function closeProblem (problem, data) {
  const url = `${URL_BASE_PROBLEMS}/${problem.id}/`
  return _patch(url, data)
}

export function createProblem (data) {
  const url = `${URL_BASE_PROBLEMS}/`
  return _save(url, data, true)
}

export function updateProblem (problemId, data) {
  const url = `${URL_BASE_PROBLEMS}/${problemId}/?format=expanded`
  return _patch(url, data)
}

export function getProblemHistory (id) {
  const url = `${URL_BASE_PROBLEMS}/${id}/history/`
  return _get(url)
}

export function getProblemDetail (problemId) {
  const url = `problem_details/?problem=${problemId}`
  return _get(url)
}

export function updateProblemQuestion (problemDocumentationId, data) {
  const url = `problem_documentation/${problemDocumentationId}/`
  return _patch(url, data)
}

export function getDocuments (documentsId) {
  const url = `${getDocumentsURL()}?ids=${documentsId.join(',')}`
  return _get(url)
}

export function uploadDocument (data) {
  return _post(getDocumentsURL(), data)
}

export function removeDocument (id) {
  const url = `${getDocumentsURL()}${id}/`
  return _delete(url)
}

export function getDeviationsById (id) {
  let url = `${URL_BASE_DEVIATION}/`
  url += `?problem=${id}`
  url += '&format=expanded'
  return _get(url)
}

export function getProblemSettings (baseUrl) {
  const url = `${baseUrl}/`
  return _get(url)
}

export function saveProblemSettings (baseUrl, data) {
  const url = `${baseUrl}/`
  return _save(url, data, true)
}

export function updateProblemSettings (baseUrl, data, id) {
  const url = `${baseUrl}/${id}/`
  return _patch(url, data)
}

export function updateProblemsSettingsField (baseUrl, data) {
  const url = `${baseUrl}/`
  return _patch(url, data)
}

export function getProblemCauseToolSettings () {
  const url = `${URL_BASE_PROBLEM_CAUSETOOL_SETTINGS}/?active=true`
  return _get(url)
}

export function saveProblemCauseToolSettings (data) {
  const url = `${URL_BASE_PROBLEM_CAUSETOOL_SETTINGS}/`
  return _save(url, data, true)
}

export function updateProblemCauseToolSettings (data, id) {
  const url = `${URL_BASE_PROBLEM_CAUSETOOL_SETTINGS}/${id}/`
  return _patch(url, data)
}

export function updateProblemsCauseToolSettingsField (data) {
  const url = `${URL_BASE_PROBLEM_CAUSETOOL_SETTINGS}/`
  return _patch(url, data)
}

export function getProblemCauseTool (problemId) {
  const url = `${URL_BASE_PROBLEM_CAUSETOOL}/?format=expanded&problem=${problemId}`
  return _get(url)
}

export function saveCauseToolCriterionInProblem (data) {
  const url = `${URL_BASE_PROBLEM_CAUSETOOL}/`
  return _save(url, data, true)
}

export function updateCauseToolCriterionInProblem (id, data) {
  const url = `${URL_BASE_PROBLEM_CAUSETOOL}/${id}/`
  return _patch(url, data)
}

export function saveDeviation (data) {
  const url = `${URL_BASE_DEVIATION}/`
  return _save(url, data, true)
}

export function updateDeviation (id, data) {
  const url = `${URL_BASE_DEVIATION}/${id}/`
  return _save(url, data, false)
}

export function deleteDeviation (id) {
  const url = `${URL_BASE_DEVIATION}/${id}/`
  return _delete(url)
}

export function getCauseCategories () {
  const url = `${URL_BASE_PROBLEM_CAUSE_CATEGORIES}/`
  return _get(url)
}

export function getRootCauses (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_ROOT_CAUSE}/?${queryParams}` : `${URL_BASE_ROOT_CAUSE}/`
  return _get(url)
}

export function getRootCauseById (id, expanded = false) {
  let url = `${URL_BASE_ROOT_CAUSE}/${id}/`
  if (expanded) { url += '?format=expanded' }
  return _get(url)
}

export function saveRootCause (data) {
  const url = `${URL_BASE_ROOT_CAUSE}/`
  return _save(url, data, true)
}

export function updateRootCause (id, data) {
  const url = `${URL_BASE_ROOT_CAUSE}/${id}/`
  return _save(url, data, false)
}

export function deleteRootCause (id) {
  const url = `${URL_BASE_ROOT_CAUSE}/${id}/`
  return _delete(url)
}

export function getDefectById (id) {
  const url = `${URL_BASE_DEFECTS}/${id}/`
  return _get(url)
}

export function getNOKIntructions () {
  const url = `${URL_BASE_NOK_INSTRUCTIONS}/`
  return _get(url)
}

export function getDepartments () {
  const url = `${URL_BASE_DEPARTMENTS}/`
  return _get(url)
}

export function getDepartmentById (departmentId) {
  const url = `${URL_BASE_DEPARTMENTS}/${departmentId}/`
  return _get(url)
}

export function saveDepartment (data) {
  const url = `${URL_BASE_DEPARTMENTS}/`
  return _save(url, data, true)
}

export function patchDepartment (departmentId, data) {
  const url = `${URL_BASE_DEPARTMENTS}/${departmentId}/`
  return _patch(url, data)
}

export function deleteDepartment (departmentId) {
  const url = `${URL_BASE_DEPARTMENTS}/${departmentId}/`
  return _delete(url)
}

export function getStandardCompliances (params) {
  let url = `${URL_BASE_STANDARD_COMPLIANCES}/`
  if (params) {
    url += `?${getUrlQueryParameterFromObject(params)}`
  }
  return _get(url)
}

export function getStandardCompliancesHistory (params) {
  let url = `${URL_BASE_STANDARD_COMPLIANCES_HISTORY}/`
  if (params) {
    url += `?${getUrlQueryParameterFromObject(params)}`
  }
  return _get(url)
}

export function saveStandardCompliance (data) {
  const url = `${URL_BASE_STANDARD_COMPLIANCES}/`
  return _save(url, data, true)
}

export function getILUMatrix (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const endpoint = parameters.date ? URL_BASE_ILU_MATRIX_HISTORY : URL_BASE_ILU_MATRIX
  const url = queryParams ? `${endpoint}/?${queryParams}` : `${URL_BASE_ILU_MATRIX}/`
  return _get(url)
}

export function getTeams (format) {
  const formatParam = format ? `?format=${format}` : ''
  const url = `${URL_BASE_TEAMS}/${formatParam}`
  return _get(url)
}

export function saveTeam (data) {
  const url = `${URL_BASE_TEAMS}/`
  return _save(url, data, true)
}

export function updateTeam (id, data) {
  const url = `${URL_BASE_TEAMS}/${id}/`
  return _patch(url, data)
}

export function deleteTeam (id) {
  const url = `${URL_BASE_TEAMS}/${id}/`
  return _delete(url)
}

export function getMessageCreators () {
  const url = `${URL_BASE_DAILY_ROUND_MESSAGES}/creators/`
  return _get(url)
}

export function getDailyRoundMessageById (messageId) {
  const url = `${URL_BASE_DAILY_ROUND_MESSAGES}/${messageId}/`
  return _get(url)
}

export function saveDailyRoundMessage (data) {
  const url = `${URL_BASE_DAILY_ROUND_MESSAGES}/`
  return _save(url, data, true)
}

export function updateDailyRoundMessage (messageId, data) {
  const url = `${URL_BASE_DAILY_ROUND_MESSAGES}/${messageId}/`
  return _patch(url, data)
}

export function deleteDailyRoundMessage (messageId) {
  const url = `${URL_BASE_DAILY_ROUND_MESSAGES}/${messageId}/`
  return _delete(url)
}

export function getDailyRoundCheckpoints (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_DAILY_ROUND_CHECK_POINTS}/?${queryParams}` : `${URL_BASE_DAILY_ROUND_CHECK_POINTS}/`
  return _get(url)
}

export function getDailyRoundById (id) {
  const url = `${URL_BASE_MY_ROUTINES}/${id}/?include-collaborators-schedules=true`
  return _get(url)
}

export function getScheduleOwners () {
  const url = `${URL_BASE_MY_ROUTINES}/creators/?include-collaborators-schedules=true`
  return _get(url)
}

export function getDailyRoundByWeekDay (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_MY_ROUTINES}/?${queryParams}`
  return _get(url)
}

export function deleteDailyRound (id) {
  const url = `${URL_BASE_MY_ROUTINES}/${id}/`
  return _delete(url)
}

export function getDailyRoundCheckpointById (id, includeCollaboratorsCheckPoints) {
  let url = `${URL_BASE_DAILY_ROUND_CHECK_POINTS}/${id}/`
  if (includeCollaboratorsCheckPoints) {
    url += `?include-collaborators-check-points=${includeCollaboratorsCheckPoints}`
  }
  return _get(url)
}

export function saveDailyRoundCheckpoints (data) {
  const url = `${URL_BASE_DAILY_ROUND_CHECK_POINTS}/`
  return _save(url, data, true)
}

export function editDailyRoundCheckPoint (id, data) {
  const url = `${URL_BASE_DAILY_ROUND_CHECK_POINTS}/${id}/`
  return _patch(url, data)
}

export function getDailyRoundScheduleEntries (schedules, format = 'table') {
  const url = `${URL_BASE_DAILY_ROUND_SCHEDULE_ENTRIES}/?format=${format}&schedules=${schedules}`
  return _get(url)
}

export function getDailyRoundScheduleEntry (entry) {
  const url = `${URL_BASE_DAILY_ROUND_SCHEDULE_ENTRIES}/${entry}/`
  return _get(url)
}

export function deleteDailyRoundCheckPoint (id) {
  const url = `${URL_BASE_DAILY_ROUND_CHECK_POINTS}/${id}/`
  return _delete(url)
}

export function getDailyRoundCheckpointsCategories () {
  const url = `${URL_BASE_DAILY_ROUND_CHECK_POINTS_CATEGORIES}/`
  return _get(url)
}

export function createCategory (urlBase, data, isNew) {
  const url = `${urlBase}/`
  return _save(url, data, isNew)
}

export function updateCategoryById (urlBase, id, data) {
  const url = `${urlBase}/${id}/`
  return _patch(url, data)
}

export function getCategoryById (urlBase, id) {
  const url = `${urlBase}/${id}/`
  return _get(url)
}

export function deleteCategoryById (urlBase, id) {
  const url = `${urlBase}/${id}/`
  return _delete(url)
}

export function getTaskManagerTypeOfCategories () {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS_CATEGORIES}/`
  return _get(url)
}

export function getTaskManagerSuperCategories () {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS_SUPER_CATEGORIES}/`
  return _get(url)
}

export function getTaskManagerAssessors () {
  const url = `${URL_BASE_TASK_MANAGER_ASSESSORS}/`
  return _get(url)
}

export function getCheckPointsByPerimeter (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/?${queryParams}` : `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/`
  return _get(url)
}

export function getCheckPointAssignmentsInPerimeter (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_CHECK_POINTS_ASSIGNMENT_IN_PERIMETER}/?${queryParams}` : `${URL_BASE_CHECK_POINTS_ASSIGNMENT_IN_PERIMETER}/`
  return _get(url)
}

export function getTaskGroups () {
  const url = `${URL_BASE_TASK_GROUPS_LIST}/`
  return _get(url)
}

export function getTaskGroupsByPerimeter (perimeterId) {
  const url = `${URL_BASE_TASK_GROUPS_LIST}/?perimeters=${perimeterId}`
  return _get(url)
}

export function addTaskGroup (group) {
  const url = `${URL_BASE_TASK_GROUPS_LIST}/`
  return _save(url, group, true)
}

export function removeTaskGroup (groupId) {
  const url = `${URL_BASE_TASK_GROUPS_LIST}/${groupId}/`
  return _delete(url)
}

export function editTaskGroup (groupId, editedParams) {
  const url = `${URL_BASE_TASK_GROUPS_LIST}/${groupId}/`
  return _patch(url, editedParams)
}

export function duplicateTaskGroup (groupId) {
  const groupToDuplicate = {
    id: groupId,
    duplicate: true,
  }
  return addTaskGroup(groupToDuplicate)
}

export function addTaskGroupPlanning (data) {
  const url = `${URL_BASE_TASK_GROUPS_PLANNING_LIST}/`
  return _save(url, data, true)
}

export function getTaskGroupPlanning (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TASK_GROUPS_PLANNING_LIST}/?${queryParams}` : `${URL_BASE_TASK_GROUPS_PLANNING_LIST}/`
  return _get(url)
}
/**
 *
 * @param {number} standardId
 * @returns {AbortablePromise}
 */
export function getTaskGroupPlanningPerWeeks (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TASK_GROUPS_PLANNING_LIST}/planning-per-weeks/?${queryParams}` : `${URL_BASE_TASK_GROUPS_PLANNING_LIST}/`
  return new AbortablePromise((resolve, reject) => {
    _get(url)
      .then(response => {
        resolve(response)
      }).catch(e => {
        reject(e)
      })
  })
}

export function getPlannedGroupSchedule (parameters, format = '') {
  parameters.format = format
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/?${queryParams}` : `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/`
  return _get(url)
}

export function getPlannedGroupSchedules (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/base-list/?${queryParams}` : `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/base-list/`
  return _get(url)
}

export function addPlannedGroupSchedule (data) {
  const url = `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/`
  return _save(url, data, true)
}

export function updatePlannedGroupSchedule (plannedGroupScheduleId, data) {
  const url = `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/${plannedGroupScheduleId}/`
  return _patch(url, data)
}

export function removePlannedGroupSchedule (plannedGroupScheduleId) {
  const url = `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/${plannedGroupScheduleId}/`
  return _delete(url)
}

export function replanPlannedExpiredGroupSchedule (data) {
  const url = `${URL_BASE_TASK_PLANNED_GROUP_SCHEDULES}/replan/`
  return _save(url, data, true)
}

export function getPerimetersAssigned (checkpoint) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/?check_point=${checkpoint}&no_group=true`
  return _get(url)
}

export function deassignCheckPoint (checkpoint) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/${checkpoint}/`
  return _delete(url)
}

export function assignCheckPoint (data) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/`
  return _save(url, data, true)
}

export function updateAssignment (assignmentID, data) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/${assignmentID}/`
  return _patch(url, data)
}

export function removeAssignments (data) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/?ids=${data}`
  return _delete(url)
}

export function patchCheckPointAssignments (data) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT}/`
  return _patch(url, data)
}

export function updateCheckPointAssignmentInPerimeter (assignmentInPerimeterId, data) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT_IN_PERIMETER}/${assignmentInPerimeterId}/`
  return _patch(url, data)
}

export function createAssignmentInPerimeter (data) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT_IN_PERIMETER}/`
  return _save(url, data, true)
}

export function removeAssignmentInPerimeter (assignmentInPerimeterId) {
  const url = `${URL_BASE_CHECK_POINTS_ASSIGNMENT_IN_PERIMETER}/${assignmentInPerimeterId}/`
  return _delete(url)
}

export function patchCheckPoint (id, data) {
  const url = `${URL_BASE_DAILY_ROUND_CHECK_POINTS}/${id}/`
  return _patch(url, data)
}

export function saveTaskManagerCheckPoint (data) {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS}/`
  return _save(url, data, true)
}

export function editTaskManagerCheckPoint (id, data) {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS}/${id}/`
  return _patch(url, data)
}

export function removeTaskManagerCheckPoint (id) {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS}/${id}/`
  return _delete(url)
}

export function getTaskManagerCheckPoint (id) {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS}/${id}/?format=expanded`
  return _get(url)
}

export function getCompletedTaskById (id) {
  const url = `${URL_BASE_TASK_MANAGER_ASSESSMENTS}/${id}/?format=expanded`
  return _get(url)
}

export function getCompletedTaskStandardGroupById (id) {
  const url = `${URL_BASE_TASK_MANAGER_STANDARD_GROUPS_LAUNCHED}/${id}/`
  return _get(url)
}

export function getCompletedTaskOnDemandGroupById (id) {
  const url = `${URL_BASE_TASK_MANAGER_ON_DEMAND_GROUPS_LAUNCHED}/${id}/`
  return _get(url)
}

export function getCheckpointAssessmentsByParameters (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TASK_MANAGER_ASSESSMENTS}/?${queryParams}` : `${URL_BASE_TASK_MANAGER_ASSESSMENTS}/`
  return _get(url)
}

export function getTaskManagerTools () {
  const url = `${URL_BASE_TASK_MANAGER_TOOLS}/`
  return _get(url)
}



export function getTaskManagerTechnicalModules () {
  const url = `${URL_BASE_TASK_MANAGER_TECHNICAL_MODULE}/`
  return _get(url)
}

export function getTaskManagerCheckPointNotAssigned (perimeterId) {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS}/?format=minimal&not_assigned_to_perimeter=${perimeterId}`
  return _get(url)
}

export function createAchieveRule (data) {
  const url = `${URL_BASE_TASK_MANAGER_ACHIEVE_RULES}/`
  return _post(url, data)
}

export function updateAchieveRule (achieveRule) {
  const url = `${URL_BASE_TASK_MANAGER_ACHIEVE_RULES}/${achieveRule.id}/`
  return _patch(url, achieveRule)
}

export function deleteTaskManagerAchieveRule (id) {
  const url = `${URL_BASE_TASK_MANAGER_ACHIEVE_RULES}/${id}/`
  return _delete(url)
}

export function getAchieveRulesByParameters (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TASK_MANAGER_ACHIEVE_RULES}/?${queryParams}` : `${URL_BASE_TASK_MANAGER_ACHIEVE_RULES}/`
  return _get(url)
}

export function createCoreEvidence (data) {
  const url = `${URL_BASE_CORE_EVIDENCES}/`
  return _post(url, data)
}

export function patchCoreEvidence (id, data) {
  const url = `${URL_BASE_CORE_EVIDENCES}/${id}/`
  return _patch(url, data)
}

export function deleteCoreEvidence (id) {
  const url = `${URL_BASE_CORE_EVIDENCES}/${id}/`
  return _delete(url)
}

export function getSourceActions () {
  const url = `${URL_BASE_ACTIONS_SOURCE}/?active=true`
  return _get(url)
}

export function saveSourceSettings (data) {
  const url = `${URL_BASE_ACTIONS_SOURCE}/`
  return _save(url, data, true)
}

export function updateSourceSettings (data, id) {
  const url = `${URL_BASE_ACTIONS_SOURCE}/${id}/`
  return _patch(url, data)
}

export async function _saveBinary (url, data = null) {
  if (data) {
    try {
      return await apiService
        .buildRequest()
        .withSessionToken()
        .withResponseType('blob')
        .post(url, data)
    } catch (error) {
      return error.message
    }
  }
  try {
    return await apiService
      .buildRequest()
      .withSessionToken()
      .withResponseType('blob')
      .get(url)
  } catch (error) {
    return error.message
  }
}

export function getILUEvaluationReasons () {
  const url = `${API_URL}/${URL_BASE_ILU_EVALUATION_RESULT}/`
  return _get(url)
}

export function saveILUEvaluationReasons (data, create = false) {
  const url = `${API_URL}/${URL_BASE_ILU_EVALUATION_RESULT}/`
  return _save(url, data, create)
}

export function getILUNoCompliantObservations (params) {
  const queryParams = getUrlQueryParameterFromObject(params)
  let url = `${API_URL}/${URL_BASE_ILU_NO_COMPLIANT_OBSERVATIONS}/`
  if (queryParams) {
    url += `?${queryParams}`
  }
  return _get(url)
}

export function getComplianceLevels () {
  const url = `${API_URL}/${URL_BASE_COMPLIANCE_LEVELS}/`
  return _get(url)
}

export function createPPE (data) {
  const url = `${URL_BASE_PPES}/`
  return _post(url, data)
}

export function getPPE (id) {
  const url = `${URL_BASE_PPES}/${id}/?format=expanded`
  return _get(url)
}

export function getPPEs (type, formatExpanded) {
  let url = `${URL_BASE_PPES}/?type=${type}`
  if (formatExpanded) {
    url += '&format=expanded'
  }
  return _get(url)
}

export function updatePPE (id, data) {
  const url = `${URL_BASE_PPES}/${id}/`
  return _save(url, data, false)
}

export function removePPE (id) {
  const url = `${URL_BASE_PPES}/${id}/`
  return _delete(url)
}

export function getSwrOperators () {
  const url = `${URL_BASE_STANDARD_WORK_REVIEW_OPERATORS}/`
  return _get(url)
}

export function getInterventionModes () {
  const url = `${URL_BASE_TASK_MANAGER_CHECK_POINTS_INTERVENTION_MODES}/`
  return _get(url)
}

export function generateToken (personId, { validUntil, name }) {
  const url = `${URL_BASE_PEOPLE}/${personId}/${URL_BASE_TOKENS}/`
  return _post(url, {
    valid_to: validUntil,
    name: name,
  })
}

export function removeToken (personId, tokenId) {
  const url = `${URL_BASE_PEOPLE}/${personId}/${URL_BASE_TOKENS}/${tokenId}/`
  return _delete(url)
}

export function getPersonNotifications (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  let url = `${API_URL}/utilities/notifications/`
  url = queryParams ? `${url}?${queryParams}` : url
  return _get(url)
}

export function generateURLToShare ({ object_id, source, validUntil, name }) {
  const url = `${URL_BASE_TO_SHARE}/`
  return _post(url, {
    object_id: object_id,
    source: source,
    valid_to: validUntil,
    name: name,
  })
}

export function removeURLToShare (tokenId) {
  const url = `${URL_BASE_TO_SHARE}/${tokenId}/`
  return _delete(url)
}

export function fetchPMMEquipments () {
  const url = `${URL_BASE_PMM_EQUIPMENTS}/`
  return _get(url)
}

export function getProblemEscalateTechniques () {
  const url = `${URL_PROBLEM_SCALATE_TECHNIQUE}/`
  return _get(url)
}
